import isEmpty from 'lodash/isEmpty';
import shallow from 'zustand/shallow';
import { useBooking } from '../state';
import { useIntl } from 'react-intl';
import { useMemo } from 'react';

interface SeatsSelectionStatusModel {
  isThereSelectedSeats: boolean;
  isValidOfferSeatsSelection: boolean;
  offerMinSelectedSeatsNumber: number | null;
  offerMinSelectedSeatsTypes: string | null;
}

type UseSeatsSelectionStatusFunc = () => SeatsSelectionStatusModel;

export const useSeatsSelectionStatus: UseSeatsSelectionStatusFunc = () => {
  const intl = useIntl();
  const booking = useBooking(s => s.booking, shallow);

  const isThereSelectedSeats = useMemo(
    () =>
      Boolean(
        booking?.selectedTickets?.some(selectedTicket => !isEmpty(selectedTicket.seats))
      ),
    [booking?.selectedTickets]
  );

  const offerMinSelectedSeatsNumber = useMemo(
    () =>
      booking?.offer
        ? booking.offer.type === 'BOGO'
          ? booking.offer.minimumQuantity + booking.offer.getQuantity
          : booking.offer.minimumQuantity
        : null,

    [booking?.offer]
  );

  const offerMinSelectedSeatsTypes =
    booking?.offerAreaCategories
      ?.map(
        offerAreaCategoryCode =>
          booking?.selectedTickets?.find(
            selectedTicket => selectedTicket.areaCategoryCode === offerAreaCategoryCode
          )?.description
      )
      .join(` ${intl.formatMessage({ id: 'global.or' })} `) ?? null;

  const isValidOfferSeatsSelection = useMemo(
    () =>
      booking?.offer &&
      !isEmpty(booking?.selectedTickets) &&
      booking?.offerAreaCategories?.some(
        offerAreaCategoryCode =>
          booking?.selectedTickets?.find(
            ({ areaCategoryCode }) => areaCategoryCode === offerAreaCategoryCode
          )?.seats?.length >= offerMinSelectedSeatsNumber
      ),
    [
      booking?.offer,
      booking?.offerAreaCategories,
      booking?.selectedTickets,
      offerMinSelectedSeatsNumber,
    ]
  );

  return {
    isThereSelectedSeats,
    isValidOfferSeatsSelection,
    offerMinSelectedSeatsNumber,
    offerMinSelectedSeatsTypes,
  };
};
